import axios, { AxiosError } from "axios";

import { AnsweredQuestionWithId } from "@teamprevent/common/model";
import { TaskModel } from "@teamprevent/common/task/taskActions/models";

import { parseTaskModel } from "../../task/model";
import { ClinicalNotesAutoSaveDto } from "../../clinicalNotes/models";

const buildUrl = (customerId: string, ohCaseId: string, taskId: string) =>
    `/api/${customerId}/ohCase/${ohCaseId}/task/${taskId}/healthSurveillanceClinicalNotes`;

const saveClinicalNotes = async (customerId: string, ohCaseId: string, taskId: string, questions: AnsweredQuestionWithId[], eTag: string) => {
    try {
        return (await axios.post<ClinicalNotesAutoSaveDto>(buildUrl(customerId, ohCaseId, taskId), { data: { questions }, eTag }))?.data;
    } catch (ex) {
        const axiosError = ex as AxiosError;
        if (axiosError.response?.status === 400) {
            const error = { message: "Could not save as a newer version exists", status: 400 };
            throw error;
        } else {
            throw ex;
        }
    }
};

const submitClinicalNotes = async (customerId: string, ohCaseId: string, taskId: string) => {
    const response = await axios.post<TaskModel[]>(`${buildUrl(customerId,ohCaseId, taskId)}/complete`);
    return response.data.map(parseTaskModel);
};

export const ClinicalNotesApi = { saveClinicalNotes, submitClinicalNotes };
